import { render, staticRenderFns } from "./ServicesNavigation.vue?vue&type=template&id=9211baa6&scoped=true&"
import script from "./ServicesNavigation.vue?vue&type=script&lang=ts&"
export * from "./ServicesNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesNavigation.vue?vue&type=style&index=0&id=9211baa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9211baa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src141814727/src/web-authentication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9211baa6')) {
      api.createRecord('9211baa6', component.options)
    } else {
      api.reload('9211baa6', component.options)
    }
    module.hot.accept("./ServicesNavigation.vue?vue&type=template&id=9211baa6&scoped=true&", function () {
      api.rerender('9211baa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/ServicesNavigation.vue"
export default component.exports